let productPriceEl = document.querySelector("[data-product-price]");
let priceContainer = document.querySelector(".cusomPrice");
let priceObject = JSON.parse(localStorage.productVariants);
let variant, variantPrice;

function formatMoneyCustom(cents, format, currencyCode, addAmount = 0) {
  var currencySymbol = "$";
  var thousandsSeparator = ",";
  var decimalSeparator = ".";
  var value = "";

  // Adjust the addAmount based on currency
  if (currencyCode === "USD" || currencyCode === "PKR") {
    addAmount = 50 * 100; // Convert $50 or ₹50 to cents
  } else if (currencyCode === "GBP") {
    addAmount = 50 * 100; // Convert £50 to cents
  }

  // Update cents by adding the additional amount
  cents += addAmount;

  // Set currency symbol and separators based on currency code
  switch (currencyCode) {
    case "USD":
      currencySymbol = "$";
      thousandsSeparator = ",";
      decimalSeparator = ".";
      break;
    case "PKR":
      currencySymbol = "Rs";
      thousandsSeparator = ",";
      decimalSeparator = ".";
      break;
    case "GBP":
      currencySymbol = "£";
      thousandsSeparator = ",";
      decimalSeparator = ".";
      break;
    // Add more currencies as needed
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;

  function formatWithDelimiters(number, precision) {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      pounds = parts[0].replace(
        /(\d)(?=(\d{3})+?$)/g,
        "$1" + thousandsSeparator
      ),
      pence = parts[1] ? decimalSeparator + parts[1] : "";

    return pounds + pence;
  }

  var match = formatString.match(placeholderRegex);
  if (match) {
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
  }

  priceContainer.innerHTML = "";
  priceContainer.innerHTML =
    currencySymbol + formatString.replace(placeholderRegex, value);
}

let currentURL = new URL(location.href);
let priceToShow = "";

if (currentURL.searchParams.has("variant")) {
  variant = currentURL.searchParams.get("variant");
  variantPrice = priceObject[variant];
  priceToShow = formatMoneyCustom(
    parseInt(variantPrice),
    "{{amount}}",
    "GBP", // Change to GBP
    50 * 100 // Adding £50
  );
} else {
  variant = productPriceEl.dataset.getProductFirstVariant;
  variantPrice = priceObject[variant];
  priceToShow = formatMoneyCustom(
    parseInt(variantPrice),
    "{{amount}}",
    "GBP", // Change to GBP
    50 * 100 // Adding £50
  );
}

if (productPriceEl.dataset.tagExist == "true") {
  document
    .querySelectorAll(".select-popout__list li")
    .forEach(function (listItem) {
      listItem.addEventListener("click", function () {
        variant = this.dataset.variantId;
        variantPrice = priceObject[variant];
        priceToShow = formatMoneyCustom(
          parseInt(variantPrice),
          "{{amount}}",
          "GBP", // Change to GBP
          50 * 100 // Adding £50
        );
      });
    });
}
